import { Injectable } from "@angular/core";
import { connectBundles, connectSelectors } from "ngrx-action-bundles";
import { bundles } from "./bundles";
import { kioskSelectors } from "./selectors";

@Injectable({ providedIn: "root" })
export class MeetingRoomsKioskModel {
  actions = connectBundles(bundles);
  selectors = connectSelectors(kioskSelectors);
}
